module.exports = __webpack_public_path__ + "static/media/iOS_Developer_Randy_Cole_resume.60fcb699.pdf";